<template>
    <div style="overflow: auto;height: 100%" class="tree-box"> <!--  :default-expanded-keys="defaultKeys"  -->
        <el-tree ref="tree" :data="data" :props="defaultProps" @node-click="handleNodeClick"
            @node-expand="handleNodeExpand" @node-collapse="handleNodeCollapse" :default-checked-keys="defaultKeys"
            :default-expanded-keys="treeExpandData" @node-contextmenu="rightClick"
            :expand-on-click-node="expandOnClickNodeFlag" :accordion="accordionFlag" node-key='id'
            :highlight-current="true" :filter-node-method="filterNode">
            <span class="span-ellipis" slot-scope="{node,data}">
                <div :class="getClass(data)" :title="node.label">{{ node.label }}
                    <div v-if="data.unprocessed_num && data.unprocessed_num > 0"  @click.stop="clickMark(data)" class="mark-num">
                        {{ data.unprocessed_num }}
                    </div>
                </div>
            </span>
        </el-tree>
        <div id="menu" v-show="showMenu" @mouseleave="showMenu = !showMenu"><!--   -->
            <el-card class="box-card">
                <div class="text item" v-for='item in operateList' :key="item.code">
                    <div @click="operate(item.code)">{{ item.label }}</div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tree',
    props: {
        data: Array,
        type: String,
        currentKey: String,
        parentId: String,
        expandOnClickNodeFlag: {
            default: true,
            type: Boolean
        },
        accordionFlag: {
            default: true,
            type: Boolean
        },
        expandOnClickCustomerNodeFlag: {
            default: true,
            type: Boolean
        },
        isDefaultExpandFirst: {
            default: true,
            type: Boolean
        }
    },

    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            showMenu: false,
            currentType: '',
            operateList: [],
            defaultKeys: [],
            treeExpandData: [],
            nodeCount: 0,
            preNodeId: null,
            curNodeId: null,
            nodeTimer: null,

            isExeMounted: false

        }
    },
    watch: {
        'data': {
            deep: true,
            immediate: true,
            handler(val) {
                if (!val) return;
                // 数据更新时重新计算 unprocessed_num
                this.calculateUnprocessed(); 
                if (this.isExeMounted && this.currentKey) {
                    this.treeExpandData = []
                    this.$nextTick(() => {
                        this.$refs.tree && this.$refs.tree.setCurrentKey(this.currentKey);
                        this.treeExpandData.push(this.currentKey)
                    })
                }
            }
        }
    },
    mounted() {
        this.calculateUnprocessed(this.data);

        this.$nextTick(() => {
            if (this.currentKey) {
                this.$refs.tree && this.$refs.tree.setCurrentKey(this.currentKey);
            }
            if (this.isDefaultExpandFirst && this.data[0]) {
                this.treeExpandData.push(this.data[0].id)
            } else if (this.currentKey) {
                this.treeExpandData.push(this.currentKey)
            }
            this.isExeMounted = true
        })
    },

    methods: {
        getClass(data) {
            const has_trend_warning = data.long_trend_warning || data.short_trend_warning
            const has_trend_alarm = data.long_trend_alarm || data.short_trend_alarm
            if (has_trend_alarm) {
                return 'label-name-red'
            } else if (has_trend_warning) {
                return 'label-name-yellow'
            } else {
                return 'label-name'
            }
        },
        calculateUnprocessed() {
            if (this.data.length) {
                this.data.forEach(item => {
                    if (item.children.length) {
                        let temp = 0;
                        item.children.forEach(i => {
                            temp += Number(i.unprocessed_num)
                        })
                        item.unprocessed_num = temp;
                    }
                })
            }
        },
        filterData(val) {
            this.$refs.tree.filter(val);
        },
        filterNode(value, data, node) {
            if (!value) {
                return true;
            }
            let _array = [];//这里使用数组存储 只是为了存储值。
            this.getReturnNode(node, _array, value);
            let result = false;
            _array.forEach((item) => {
                result = result || item;
            });
            return result;
        },
        getReturnNode(node, _array, value) {
            let isPass = node.data && node.data.label && node.data.label.indexOf(value) !== -1;
            isPass ? _array.push(isPass) : '';
            this.index++;
            if (!isPass && node.parent) {
                this.getReturnNode(node.parent, _array, value);
            }
        },
        handleNodeClick(obj, node, e) {
            // if (obj.type == 'customer' && this.expandOnClickCustomerNodeFlag) {
            //     obj = obj.children[0]
            //     this.$refs.tree && this.$refs.tree.setCurrentKey(obj.id);
            // }
            //站点情况不保持
            if((obj.type != 'equipment') && (obj.type != 'point') && (obj.type != 'point') && ((obj.type != 'gateway'))){
              sessionStorage.setItem('currentNode', JSON.stringify(obj));
            }
            this.$emit('clickNode', Object.assign({}, obj, { currentPage: 1 }))
            this.nodeCount++
            if (this.preNodeId && this.nodeCount >= 2) {
                this.curNodeId = obj.id
                this.nodeCount = 0
                if (this.curNodeId == this.preNodeId) {//第一次点击的节点和第二次点击的节点id相同
                    //公司类型默认公司第一个
                    if(obj.type == 'customer'){
                      obj = obj.children[0]
                    }
                    this.$emit('doubleClick', obj)
                    this.curNodeId = null
                    this.preNodeId = null
                    return
                }
            }
            this.preNodeId = obj.id
            this.nodeTimer = setTimeout(() => { //300ms内没有第二次点击就把第一次点击的清空
                this.preNodeId = null
                this.nodeCount = 0
            }, 300)
        },
        rightClick(MouseEvent, object, Node, element) {
            if (this.type == 'site') {
                this.operateList = []
                return;
            }
            if (this.type == 'device') {
                if (object.type == "gateway") {
                    this.operateList = [
                        { code: 'del', label: '删除' },
                    ]
                } else {
                    this.operateList = []
                    return;
                }
            } else {
                this.$emit('clickNode', Object.assign({}, object, { currentPage: 1 }))
                this.$refs.tree && this.$refs.tree.setCurrentKey(object.id);
                if (object.type != 'point') {
                    this.operateList = [
                        { code: 'add', label: '添加同级' },
                        { code: 'addChild', label: '添加下级' },
                        { code: 'edit', label: '修改' },
                        { code: 'del', label: '删除' },
                    ]
                } else {
                    this.operateList = [
                        { code: 'add', label: '添加同级' },
                        { code: 'edit', label: '修改' },
                        { code: 'del', label: '删除' },
                    ]
                }
            }


            this.currentType = object
            this.showMenu = true;
            let menu = document.querySelector("#menu");
            menu.style.cssText = "position: fixed; left: " + (MouseEvent.clientX - 10) + 'px' + "; top: " + (MouseEvent.clientY - 130) + 'px; z-index: 999; cursor:pointer;';
        },
        //    点击数量触发
        clickMark(node) {
            this.$emit('clickMark', node)
        },
        operate(val) {
            this.$emit(val, this.currentType)
        },
        handleNodeExpand(obj, node, e) {

        },
        handleNodeCollapse(obj, node, e) {

        }
    }
}
</script>

<style lang='less' scoped>
/deep/.el-card__body {
    padding: 10px 0;
}

.item {
    height: 36px;
    line-height: 36px;
    width: 100px;
    text-align: center;
}

.el-tree {
    // padding :0 10px;
}

.item:not(:last-child) {
    border-bottom: solid 1px #ccc;
}

.span-ellipis {
    font-size: 12px;
}

/deep/.el-tree-node:focus>.el-tree-node__content {
    background-color: transparent !important;
}

.label-name {
    position: relative;

    .mark-num {
        position: absolute;
        top: 0;
        right: -48px;
        padding: 2px 8px;
        border-radius: 6px;
        color: #fff;
        background: #f00;
    }
}
.label-name-red {
    position: relative;
    color: rgba(218, 97, 97, 1);
    .mark-num {
        position: absolute;
        top: 0;
        right: -48px;
        padding: 2px 8px;
        border-radius: 6px;
        color: #fff;
        background: #f00;
    }
}
.label-name-yellow {
    position: relative;
    color: rgba(249, 229, 129, 1);
    .mark-num {
        position: absolute;
        top: 0;
        right: -48px;
        padding: 2px 8px;
        border-radius: 6px;
        color: #fff;
        background: #f00;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/tree.vue